import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import './index.css';
import App from './App';
import "bootstrap/dist/css/bootstrap.min.css";
import {CheckPopUp} from './components/DataContext';
import { HelmetProvider } from "react-helmet-async";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <HelmetProvider>
      <CheckPopUp>
        <React.StrictMode>
            <BrowserRouter>
                <App />
            </BrowserRouter>    
        </React.StrictMode>
      </CheckPopUp>
    </HelmetProvider>
);
